import { useHistory, useParams } from "react-router-dom";
import React, { useState, useEffect, useCallback, useRef } from 'react';
//import useFetch from "./useFetch";
import useFetch from '../../useFetch';
import { Row, Col, Container } from 'react-bootstrap';
import Banner from '../../components/banner.js';
import Sidebar from '../../components/sidebar.js';
import { Helmet } from 'react-helmet';
import parse from 'html-react-parser';
import { SearchDetailById,SearchDetailByIdD4d } from '../../Services/ProductSearchService.js'
import {  getDrugInfo,getAbbrPiByID,getProductImage } from '../../Services/Utilities.js'
import Modal from 'react-bootstrap/Modal';
import { IconSearch, IconChevronRight, IconUserSquareRounded, IconInfoCircleFilled,IconListSearch, IconCaretDownFilled, IconInfoTriangleFilled,IconArrowBadgeUpFilled, IconZoomCheckFilled, IconFilterFilled, IconX, IconTrash, IconExternalLink, IconRestore, IconArrowRight } from '@tabler/icons-react'; // Import Icon
import { useMediaQuery, Breadcrumbs, Select, InputLabel, Skeleton, CircularProgress, Accordion, AccordionSummary, ButtonGroup, AccordionDetails, TextField, Link, Checkbox,Collapse, Divider, InputAdornment, ListItemButton, ListSubheader, Alert, AlertTitle, Chip, Typography, IconButton, FormControl, FormLabel, Button, Tooltip, FormControlLabel,FormGroup, Autocomplete, Tab, Tabs, Box,Table, TableBody, TableFooter, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Pagination, Badge, Fab, Zoom, List, ListItem, ListItemIcon, ListItemText, Stack, Dialog, DialogActions, DialogContent, DialogTitle  } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { cleanUp } from "../../Services/Utilities.js";
import { logPageViews } from "../../Services/LoginService.js";
import '../../styles/ProductDetails.scss'
import Drugs4DentLogo from '../../assets/Drugs4dent.svg';
import AbbreviatedPi from '../Search/AbbreviatedPi.js'
import { ContactSupportOutlined } from "@mui/icons-material";
import { useThemeManager } from '../../Context/ThemeManager.js';

const ProductDetails = () => {
    const {theme} = useThemeManager();
    const [activeButton, setActiveButton] = useState('search');
    const { id } = useParams();
    const history = useHistory();
    const { error, isPending, data } = useFetch('api/MimsDrug4dent/GetProductById?id=' + id)
    const [abbreviatedId, setAbbreviatedId] = useState('');
    const [isModalDataLoading, setIsModalDataLoading] = useState(false)
    const [DrugInfoDetails, setDrugInfo] = useState([]);
    const [AbbrevPI, setAbbrevPI] = useState([]);
     const [BrandId, setBrandId] = useState([]);
     const [productImages, setProductImages] = useState(null);
    const [PrecautionText, setPrecautionText] = useState("");
    const [ContraindicationText, setContraindicationText] = useState("");
    const [OralEffectText, setOralEffectText] = useState([]);
    const [OralEffectTitle, setOralEffectTitle] = useState([]);
 
    const [modalShow, setModalShow] = useState(false);
    const [PrecautionmodalShow, setPrecautionmodalShow] = useState(false);
    const [OralModalShow, setOralModalShow] = useState(false);
    const [showPrecaution, setShowPrecaution] = useState(false);
    const [showInteraction, setShowInteraction] = useState(false);
    const [showDrugInfo, setShowDrugInfo] = useState(false);

    const [InteractionDetails, setInteractionDetails] = useState([]);
    const isLgScreen = useMediaQuery('(min-width:1024px)');
    
    const country = localStorage.getItem("Activecountryversion");
    useEffect(() => {
        document.title = "MIMS Product Information"
        if (country === "New Zealand") {
            document.documentElement.style.setProperty('--primary-color', theme.primary);
            document.documentElement.style.setProperty('--secondary-color', '#D99A00');
            document.documentElement.style.setProperty('--titleGradient', '#E69A00, #eba313, #eeab24');
        } else {
            document.documentElement.style.setProperty('--primary-color', theme.primary);
            document.documentElement.style.setProperty('--secondary-color', '#002195');
            document.documentElement.style.setProperty('--titleGradient', '#0262AB, #0e86e2, #0197e2');
        }
    }, [])

    useEffect(() => {
    let isCancelled = false

    async function handleEffect() {
        setAbbreviatedId('')

        if (!isPending && data?.brands?.length > 0) {
            const brandId = data.brands[0].brandId
            //console.log(brandId)
            setBrandId(brandId);
            setAbbreviatedId(brandId)
            //console.log(data)
            ///const interaction = await SearchDetailByIdD4d(brandId)
            console.log(brandId)
            const drugInfo = await getDrugInfo(brandId)
            console.log(drugInfo)
            await getProductImage("", "", "", "", "", "", brandId, "", "", "", "", 1)
                            .then((items) => {
                                setProductImages(items.data);
                            });
           
            if (isCancelled) return
            //setInteractionDetails(interaction)
            setDrugInfo(drugInfo)
            //setProductImages()
            
            
            // Check for abbreviated PI
            if (drugInfo?.abbreviatedPi != null) {
                console.log(drugInfo.abbreviatedPi.abbreviatedPiId)
                const abbrPi = await getAbbrPiByID(drugInfo.abbreviatedPi.abbreviatedPiId)
            
               
                if (isCancelled) return
                setAbbrevPI(abbrPi)
                setShowDrugInfo (true)
                // Check for precaution text
                if (abbrPi?.content?.[2]?.text?.length > 0) {
                    setPrecautionText(abbrPi.content[2].text)
                    setShowPrecaution (true)
                }
            }
            setShowInteraction(true)
        }

        // Logging
        if (data?.productName) {
            await logPageViews('Product', data.productName)
        }
    }

    handleEffect()

    return () => {
        isCancelled = true
    }
}, [data, isPending])



    const [modalTitle, setModalTitle] = useState('')
    const [modalBody, setModalBody] = useState('')
    const [modalButtonType, setModalButtonType] = useState(null);
    const handleModalButtons = (buttonType) => {

        setModalButtonType(buttonType);

        if (buttonType === 0) {
          if (isLgScreen) {
              handleRedirect(); 
              return;
          } else {
              setModalTitle("Interaction Checker");
              setShowButtonModal(true);
          }
      }
        else if (buttonType === 1) {
            setModalTitle("Contraindication & Precaution");
            AbbrevPI.content.map(e => {
                        if (e.header == "Precautions") { setPrecautionText(parse(e.text)) }
                        if (e.header == "Contraindications") { setContraindicationText(parse(e.text)) }
                    })
            setShowButtonModal(true);
        } 
        else if (buttonType === 2) {
            setModalTitle("MIMS Drug Information");
            setShowButtonModal(true);
        }
        else if (buttonType === 3) {
            setModalTitle("Oral Adverse Effects");
            setShowButtonModal(true);
        }
    };
const [items, setItems] = useState(() => {
    const savedItems = localStorage.getItem('Activecountryversion');
    // Parse the string into an array, default to an empty array if null
    return savedItems ? (savedItems) : '';


  });
    const handleRedirect = () => {
    //   const id = InteractionDetails[0].id;
    //   const name = InteractionDetails[0].name ?? '';
    //   const type = InteractionDetails[0].type;
      const brandId = data.brands[0].brandId
      const brandName = data.brands[0].name
      //const brandId = data.brands[0].brandId

      if (brandId) {
          history.push(`/druginteractions?id=${brandId}&name=${encodeURIComponent(brandName)}&type=brand`);
      } else {
          console.warn("No valid ID found for selected drug.");
      }
    };
    const [showButtonModal, setShowButtonModal] = useState(false);

    function linkifyText(text) {
        if (typeof text !== 'string') return text;
        
        const urlRegex = /(https?:\/\/[^\s)]+[^\s.,;!?)]?)/g;
        const parts = text.split(urlRegex);

        return parts.map((part, i) => {
            if (urlRegex.test(part)) {
            const cleanedUrl = part.replace(/[.,;!?)]$/, '');
            return (
                <a key={i} href={cleanedUrl} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-word' }}>
                {cleanedUrl}
                </a>
            );
            }
            return part;
        });
        }

    function linkifyReactElement(element) {
        if (typeof element === 'string') {
            // text node: linkify it
            return linkifyText(element);
        }
        if (React.isValidElement(element)) {
            // clone element with processed children
            const children = React.Children.map(element.props.children, child => linkifyReactElement(child));
            return React.cloneElement(element, { ...element.props, children });
        }
        if (Array.isArray(element)) {
            return element.map((el, idx) => linkifyReactElement(el));
        }
        return element;
    }
    function ButtonModal(props) {
        return (
            <Modal
                {...props}
                size={modalButtonType === 2 ? "xl" : "lg"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="drugInfoModal"
                dialogClassName={
                isLgScreen
                    ? (modalButtonType === 2 ? "custom-modal-width" : "")
                    : "modal-dialog-scrollable"
                }
            >
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex align-items-center flex-nowrap w-100">
                        <img
                            src= {Drugs4DentLogo}
                            id="logo-img"
                            alt="Logo"
                            className="me-2"
                            style={{ maxWidth: isLgScreen ? "140px" : "120px", height: "auto" }}
                        />
                        <h5 className="mb-0" style={{fontSize: !isLgScreen ? 16:""}}  >{modalTitle}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body
                    style={{
                        padding: isLgScreen
                        ? (modalButtonType === 2 ? 0 : undefined)
                        : (modalButtonType === 2 ? 0 : "16px 0"),
                        height: modalButtonType === 2
                        ? "calc(100dvh - 200px)"
                        : undefined,
                    }}
                >
                    {modalButtonType === 0 ? (
                        <h5 style={{ lineHeight: 1.5 }}>
                        Would you like to check interactions for{" "}
                        <span style={{ fontWeight: "bold", color: theme.primary }}>
                            {data.brands &&
                            data.brands.map((blog, index) => (
                                <React.Fragment key={index}>
                                {parse(blog.name)}
                                {index < data.brands.length - 1 && ", "}
                                </React.Fragment>
                            ))}
                        </span>
                        ?
                        </h5>
                    ) : modalButtonType === 1 ? (
                        <>
                        {ContraindicationText != "" &&
                        <div className="mb-3">
                            <h5>Contraindications: </h5>
                            <div>{ContraindicationText}</div>
                        </div>
                        }
                        {PrecautionText != "" &&
                            <div>
                                <h5>Precautions: </h5>
                                <div>{PrecautionText}</div>
                            </div>
                        }
                        </>
                    ) : modalButtonType === 2 ? (
                        <>
                        <div className="AbbreviatedBox">
                            
                            {items === "Australia" ? 
                            <iframe className="iframeStyle" src={"https://app.emims.plus/medicineview?id=" + abbreviatedId + "&type=abbpi&hideNavigation=true&token=raghav-plus"} loading='eager'></iframe> : 
                            <AbbreviatedPi abbrpis={AbbrevPI} drugInfo={DrugInfoDetails} brandId={BrandId} productImages={productImages}/>}
                            
                            {/* <iframe className="iframeStyle" src={"https://app.emims.plus/medicineview?id=" + abbreviatedId + "&type=abbpi&hideNavigation=true&token=raghav-plus"} loading='eager'></iframe> */}
                        </div>
                        </>

                    ): 
                        <div>
                            <h5>{OralEffectTitle}</h5>
                            <div>{OralEffectText}</div>
                        </div>
                            }
                </Modal.Body>

                {modalButtonType === 0 && ( <>
                <Modal.Footer style={{ display: "flex", gap: "8px", width: "100%", flexWrap: "wrap", paddingTop: "20px" }}>
                
                  <Button
                  variant="text"
                  onClick={() => setShowButtonModal(false)}
                  sx={{
                      flex: 1,
                      borderRadius: "12px",
                      padding: "12px",
                      minWidth: "fit-content",
                      whiteSpace: "nowrap",
                      color: 'text.secondary',
                      fontWeight: "bold"
                  }}
                  >
                  Cancel
                  </Button>
                
                  <Button
                      variant="contained"
                      type="submit"
                      onClick={handleRedirect}
                      sx={{
                      flex: 1,
                      borderRadius: "12px",
                      minWidth: "fit-content",
                      padding: "12px",
                      backgroundColor: theme.primary,
                      whiteSpace: "nowrap"
                      }}
                      startIcon={<IconZoomCheckFilled />}
                  >
                      Proceed
                  </Button>
                </Modal.Footer>
                </> )}
            </Modal>
        );
    }

    
    return (
    <>
        <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        <ButtonModal
        show={showButtonModal}
        onHide={() => setShowButtonModal(false)}
        />
        <Banner />
        <Sidebar activeButton={activeButton} />
        <div id="ProductDetails">
            <Container fluid id="main">
                <div id="content">
                    {data.productName && (<>
                    {isLgScreen &&
                    <div className="mb-3">
                        <Breadcrumbs aria-label="breadcrumb">
                            <Typography color="inherit">Search Results</Typography>
                            <Typography sx={{ color: 'text.primary', fontWeight: "bold" }}>{parse(data.productName)}</Typography>
                        </Breadcrumbs>
                    </div>
                    }
                    <Row id="product" className={ isLgScreen ? 'mb-2 d-flex flex-row' : 'mt-4 d-flex flex-row'}>
                        <div className={isLgScreen ? "d-flex" : "d-flex p-0"}>
                            <h3 style={{color: theme.primary, fontWeight: "bold"}}>{parse(data.productName)}</h3>
                            {data.mimsClasses?.length === 0 && (
                                <h6 style={{ marginLeft: '12px', fontColor: "#727272" }}>(Discontinued)</h6>
                            )}
                        </div>
                        {isLgScreen ? (<>
                        <div className="d-flex" style={{ gap: 16, marginTop: 12 }}>
                        {showInteraction ? (
                            <>
                            <Button
                                variant="contained"
                                onClick={() => handleModalButtons(0)}
                                sx={{
                                py: 1,
                                px: 2,
                                bgcolor: theme.primary,
                                color:"#fff",
                                borderRadius: '12px',
                                textTransform: "none",
                                fontSize: 12
                                }}
                                startIcon={
                                <img
                                    src="/MenuIcons/Active/SVG/Interactions.svg"
                                    alt="icon"
                                    style={{ width: 20, height: 20 }}
                                />
                                }
                            >
                                Drug & Allergy Interactions
                            </Button>

                            {showPrecaution && (
                                <Button
                                variant="contained"
                                onClick={() => handleModalButtons(1)}
                                sx={{
                                    py: 1,
                                    px: 2,
                                    bgcolor: theme.primary,
                                    color:"#fff",
                                    borderRadius: '12px',
                                    textTransform: "none",
                                    fontSize: 12
                                }}
                                startIcon={
                                    <img
                                    src="/Contraindication.svg"
                                    alt="icon"
                                    style={{ width: 20, height: 20 }}
                                    />
                                }
                                >
                                Contraindications & Precautions
                                </Button>
                            )}

                            {showDrugInfo && (
                                <Button
                                variant="contained"
                                onClick={() => handleModalButtons(2)}
                                sx={{
                                    py: 1,
                                    px: 2,
                                    bgcolor: theme.primary,
                                    color:"#fff",
                                    borderRadius: '12px',
                                    textTransform: "none",
                                    fontSize: 12
                                }}
                                startIcon={
                                    <img
                                    src="/eMIMSplusLogo.svg"
                                    alt="icon"
                                    style={{ maxWidth: 24, height: 24 }}
                                    />
                                }
                                >
                                MIMS Drug Information
                                </Button>
                            )}
                            </>
                        ) : (
                            <>
                            <Skeleton
                                variant="rectangular"
                                width={220}
                                height={40}
                                sx={{ borderRadius: '12px' }}
                            />
                            <Skeleton
                                variant="rectangular"
                                width={220}
                                height={40}
                                sx={{ borderRadius: '12px' }}
                            />
                            <Skeleton
                                variant="rectangular"
                                width={220}
                                height={40}
                                sx={{ borderRadius: '12px' }}
                            />
                            </>
                        )}
                        </div>

                        </>) : (<>
                       
                        <div className="d-flex p-0 mt-2">
                            {showInteraction ? (
                                <ButtonGroup fullWidth variant="contained" aria-label="Basic button group"  size="small" sx={{ borderRadius: "12px",borderColor: "#ffffff",  '& .MuiButton-root': {
                                py: "4px", 
                                minHeight: 'unset', 
                                },}}>
                                <Button 
                                    onClick={() => handleModalButtons(0)}
                                    sx={{ py: "12px", borderRadius: "12px", color: "#fff", bgcolor: theme.primary, border: "1px solid #fffff" }}><img
                                    src="/MenuIcons/Active/SVG/Interactions.svg"
                                    alt="Interactions"
                                    style={{ width: 24, height: 24 }}
                                    />
                                </Button>

                                {showPrecaution && (
                                    <Button 
                                    onClick={() => handleModalButtons(1)}
                                    sx={{ py: "12px", borderRadius: "12px", color: "#fff", bgcolor: theme.primary, border: "1px solid #fffff" }}><img
                                        src="/Contraindication.svg"
                                        alt="icon"
                                        style={{ width: 24, height: 24 }}
                                    />
                                </Button>
                                )}

                                {showDrugInfo && (
                                   <Button 
                                onClick={() => handleModalButtons(2)}
                                sx={{ py: "12px", borderRadius: "12px", color: "#fff", bgcolor: theme.primary, border: "1px solid #fffff" }}><img
                                    src="/eMIMSplusLogo.svg"
                                    alt="icon"
                                    style={{ width: 32, height: 32 }}
                                />
                                </Button>
                                )}
                                </ButtonGroup>
                            ) : (
                                // fallback skeletons
                                <>
                               <Box width="100%" display="flex" justifyContent="center"  gap={1} >
                                    <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: '12px' }} />
                                    <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: '12px' }} />
                                    <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: '12px' }} />
                                </Box>
                                </>
                            )}
                            </div>

                        </>)}
                        
                        <hr className="my-3"/>
                        <Row>
                            <Col lg={12} className={isLgScreen ? "" : "p-0"}>
                                <div className="d-flex flex-column mb-3">
                                    <strong style={{color: "#727272"}}>Brand Name </strong>
                                    <span> {data.brands && data.brands.map(blog => (
                                        parse(blog.name) ))}
                                    </span>
                                </div>
                                {data.mimsClasses?.length > 0 &&
                                <div className="d-flex flex-column my-3">
                                    <strong style={{color: "#727272"}}>Drug Class </strong>
                                    <ul style={{ marginBottom: 0, listStyleType: data.mimsClasses.length == 1 ? "none" : "", paddingLeft: data.mimsClasses.length == 1 ? 0 : "2rem" }}>
                                        {data.mimsClasses.map(blog => (
                                            <li key={blog.id}>{blog.name}</li>
                                        ))}
                                    </ul>
                                </div>
                                }
                                {data.acgs?.length > 0 &&
                                <div className="d-flex flex-column my-3">
                                    <strong style={{color: "#727272"}}>Active Ingredients </strong>
                                    <ul style={{ marginBottom: 0, listStyleType: data.acgs.length == 1 ? "none" : "", paddingLeft: data.acgs.length == 1 ? 0 : "2rem" }}>
                                        {data.acgs.map(blog => (
                                            <li key={blog.id}>{blog.name}</li>
                                        ))}
                                    </ul>
                                </div>
                                }
                                {data.indications.length > 0 &&
                                <div className="d-flex flex-column my-3">
                                    <strong style={{color: "#727272"}}>Indiciations </strong>
                                    <ul style={{ marginBottom: 0, listStyleType: data.indications.length == 1 ? "none" : "", paddingLeft: data.indications.length == 1 ? 0 : "2rem" }}>
                                        {data.indications.map(blog => (
                                            <li key={blog.id}>{blog.name}</li>
                                        ))}
                                    </ul>
                                </div>
                                }
                                <div className="d-flex flex-column my-3">
                                    <strong style={{color: "#727272"}}>Dental Procedural Considerations </strong>
                                    {data.proceduralConsiderations == '' ?
                                    <span style={{fontStyle: "italic", color: "#727272"}}> Under Review</span>
                                    :
                                    <ul style={{ marginBottom: 0, listStyleType: data.proceduralConsiderations.length <= 1 ? "none" : "", paddingLeft: data.proceduralConsiderations.length <= 1 ? 0 : "2rem" }}>
                                        {data.proceduralConsiderations.map(blog => (
                                            <li key={blog.id}>
                                            {linkifyReactElement(cleanUp(blog.name))}
                                            </li>
                                        ))}
                                    </ul>
                                    }
                                </div>
                                <div className="d-flex flex-column my-3">
                                    <strong style={{color: "#727272"}}>Oral Adverse Effects</strong>
                                    {data.oralAdversEffects == '' ?
                                    <span style={{fontStyle: "italic", color: "#727272"}}> Under Review</span>
                                    :
                                    <ul
                                    style={{
                                        marginBottom: 0,
                                        listStyleType: data.oralAdversEffects.length <= 1 ? "none" : "disc",
                                        paddingLeft: data.oralAdversEffects.length <= 1 ? 0 : "2rem"
                                    }}
                                    >
                                    {data.oralAdversEffects.map(blog => {
                                        const effectText = String(blog.effect).trim();
                                        return (
                                            <li key={blog.id}>
                                            {effectText !== "No known oral adverse effects" ? (
                                                <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleModalButtons(3)
                                                    setOralEffectTitle(effectText)
                                                    setOralEffectText(blog.description.split('\\n').map((instruction, index) => {
                                                        return <div key={index} className='mb-2'>{` ${instruction.split("\\r").join("")}`}</div>
                                                    }))
                                                }}
                                                >
                                                {effectText}
                                                </a>
                                            ) : (
                                                effectText
                                            )}
                                            </li>
                                        );
                                        })}

                                    </ul>

                                    }
                                </div>

                            </Col>
                        </Row>
                    </Row>
                    </>)}
                </div>
            </Container>
        </div>
        </>

    );
}

export default ProductDetails;